import React from "react";
import "./CallHistory.scss";
import CallHistory1 from "../../components/CallHistory/CallHistory";

function CallHistory() {
  return <CallHistory1 />;
}

export default CallHistory;
